import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { onConfirmDialog } from '../../../../../core/helpers/helpers.function';
import { IAvailableTypes } from '../../../../../core/models/available-types.interface';
import { PageParams } from '../../../../../core/models/page-params.model';
import { ConstantService } from '../../../../../core/services/constant.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UserService } from '../../../../../core/services/user.service';
import { UploadStatus } from '../../../../../shared/enums/shipment-price.enum';
import { ConfirmPopupDialog } from '../../../../../shared/popups/confirm-popup/confirm-popup.component';
import { IStatus } from '../../../models/shipment-price.interface';

@Component({
    selector: 'eci-table-shipment-price',
    templateUrl: './table-shipment-price.component.html',
    styleUrls: ['./table-shipment-price.component.scss']
})

export class TableShipmentPriceComponent implements OnInit {
    protected readonly UploadStatus = UploadStatus;

    @Input() dataSource;
    @Input() displayedColumns;
    @Input() availableCountries;
    @Input() pageParams: PageParams = new PageParams();
    @Output() pageChange: EventEmitter<PageParams> = new EventEmitter<PageParams>(null);
    @Output() onNavigate: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() sortRows: EventEmitter<Sort> = new EventEmitter<Sort>(null);
    // Todo: Should be generic type
    @Output() onEdit: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() onDelete: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() onManageName: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() onCoverageMap: EventEmitter<any> = new EventEmitter<any>(null);
    @Output() changeStatus: EventEmitter<IStatus> = new EventEmitter<IStatus>(null);
    @Output() public  listOfSelectedItemsChange: EventEmitter<number[]> = new EventEmitter<number[]>(null);

    @ContentChild(TemplateRef) controlTemplate: TemplateRef<any>;

    @ViewChild(MatSort) sort: MatSort;
    private listOfSelectedItems: number[] = [];
    public availableTypes: IAvailableTypes;

    constructor(
        private router: Router,
        public userSvc: UserService,
        private dialog: MatDialog,
        private constSvc: ConstantService,
        private notify: NotificationService,
    ) {
    }

    ngOnInit(): void {
        this.constSvc.availableTypes.subscribe((data) => {
            this.availableTypes = data;
        });
    }

    public getTableRowColor(row: any): string {
        switch (true) {
            case !row?.active:
                return 'gray';
            default:
                '';
        }
    }

    public pageChanged(e): void {
        this.pageChange.emit(e);
    }

    public navigateTo(row): void {
        this.onNavigate.emit(row);
    }

    public sortData(e: Sort): void {
        this.sortRows.emit(e);
    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    public getCountry(id): string {
        if (!this.availableCountries) {
            return '';
        }
        return this.availableCountries.find((country) => Number(country.id) === Number(id))?.name || '';
    }

    public getNameByArray(arr): string {
        return arr?.map((item) => item.name)
            ?.join(', ') || '';
    }

    public onChangeState(id, state): void {
        this.changeStatus.emit({
            id,
            status: state.checked,
        });
    }

    public get isAllSelected(): boolean {
        return this.listOfSelectedItems?.length > 0 &&
            this.listOfSelectedItems?.length === this.dataSource?.data?.length;
    }

    public selectAllChanged(event: MatCheckboxChange): void {
        if (event.checked) {
            this.listOfSelectedItems = this.dataSource?.data?.map((item) => item.id);
            this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
        } else {
            this.listOfSelectedItems = [];
            this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
        }
    }

    public isChecked(id: number): boolean {
        return !!this.listOfSelectedItems.find((el) => el === id);
    }

    public selectionChanged(event: MatCheckboxChange, id): void {
        if (!id) {
            return;
        }
        if (event.checked && !this.isChecked(id)) {
            this.listOfSelectedItems.push(id);
        } else if (!event.checked && this.isChecked(id)) {
            const index = this.listOfSelectedItems.findIndex((el) => el === id);
            this.listOfSelectedItems.splice(index, 1);
        }
        this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
    }

    public convertToPrice(value: any): any {
        return parseFloat(value || 0)
            .toFixed(2);
    }

   public delete(event, element): void {
       event.stopPropagation();
       const onConfirm = () => {
           this.onDelete.emit(element.id);
       };
       const dialogRef = this.dialog.open(ConfirmPopupDialog);
       onConfirmDialog(dialogRef, onConfirm, 'entity');
   }

    public onChangeActive($event: MouseEvent, element): void {
        $event.stopPropagation();
        if (element.isDisabled) {
            this.notify.showWarn(`Activation of this Vendor is possible only from the 'System Vendors entry' page.`);
        }
    }

    navigateToItemDetails(element) {
        if (!element || !element.id) {
            return;
        }
        this.router.navigateByUrl(`/shipment-price/single-price-items/${element.id}`);
        // this.router.navigate([]).then(result => { window.open(`/shipment-price/single-price-items/${element?.id}`, '_blank'); });
    }

}
